import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const TrademarkLicense = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default TrademarkLicense